module.exports = __webpack_public_path__ + "static/media/Team 36 - The Pathfinders.61078288.png";